export * from "./getInquiries";
export * from "./insertInquiry";
